import ValueEditorTextareaProperty from './ValueEditorTextareaProperty';

export default ValueEditorTextareaProperty;
export { ValueEditorTextareaProperty };
